import { PRICE_ROUNDING_SCALE } from "common/constants";
import { getPriceWithVAT, roundNumber } from "helpers";
import moment from "moment";

export const getPackagePrice = (basePrice: number | undefined, basePriceText: string | undefined, marginal: number, isCompany: boolean): string => {

    let price: string | number | undefined = basePrice;
    
    if (!price) {
        price = basePriceText;
    } else {
        price = basePrice! + marginal;
        price = isCompany ? roundNumber(price, PRICE_ROUNDING_SCALE) : getPriceWithVAT(price, PRICE_ROUNDING_SCALE, moment());
        price = price + ' s/kWh';
    }

    return price as string;
}

export const getMarginal = (marginal: number, isCompany: boolean) => {
    return isCompany ? roundNumber(marginal, 3) : getPriceWithVAT(marginal, 3, moment());
}